import React from 'react';
import { motion } from "framer-motion";
import { awardLogos } from "@/data/trustLogos";
import { LazyImage } from "@/components/ui/lazy-image";
const AwardsSection = () => {
  return <motion.div initial={{
    opacity: 0,
    y: 15
  }} whileInView={{
    opacity: 1,
    y: 0
  }} viewport={{
    once: true
  }} transition={{
    duration: 0.6
  }} className="text-center">
      <div className="flex justify-center items-center gap-8 flex-wrap">
        {awardLogos.map((award, index) => <LazyImage key={index} src={award.src} alt={award.alt} className="h-32 w-auto" />)}
      </div>
    </motion.div>;
};
export default AwardsSection;